export enum DowngradeMode {
  cancel = 'cancel',
  downgrade = 'downgrade',
  pause = 'pause',
}
